<template>
    <div class="content">
        <Session v-if="type == 'live-video'"/>
        <VideoLoop v-else-if="type == 'iframe'" :hd="true" :iframe="roomData.iframe"/>
        <ExpoMap v-else-if="type == 'map'" :expoId="expoId"/>
    </div>
</template>

<script>
import Session from '../video/Session'
import VideoLoop from './VideoLoop'
import ExpoMap from './ExpoMap'

export default {
    name: 'ExpoContent',
    props: ['type', 'expoId', 'roomDashStr', 'roomData'],
    components: {
        Session,
        VideoLoop,
        ExpoMap
    },
}
</script>